<template>
  <div class="data-setting-container">
    <strong>选择设备</strong>
    <hr />

    <div style="margin-bottom: 20px">
      <div class="device-item" v-if="device">
        <div>{{ device.deviceName }} | <span style="margin:0 15px;">{{device.deviceNo}}</span> </div>
        <div>
          <el-button
            icon="el-icon-delete-solid"
            circle
            size="mini"
            @click="removeDevice"
          ></el-button>
        </div>
      </div>
      <el-button size="mini" @click="showSelectProject = true"
        >选择设备</el-button
      >
    </div>
    <strong>MQTT</strong>
    <hr />
    <!-- <div class="event-properties-item">
      <div class="event-label">MQTT地址</div>
      <div>
        <el-input size="mini" v-model="url"></el-input>
      </div>
    </div> -->
    <div class="event-properties-item">
      <div class="event-label">Client ID</div>
      <div>
        <el-input
          size="mini"
          v-model="clientId"
          placeholder="唯一ID，可留空"
        ></el-input>
      </div>
    </div>
<!--     <div class="event-properties-item">
      <div class="event-label">用户名</div>
      <div>
        <el-input size="mini" v-model="account"></el-input>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">密码</div>
      <div>
        <el-input size="mini" type="password" v-model="password"></el-input>
      </div>
    </div> -->
    <div class="event-properties-item">
      <div class="event-label">MQTT订阅主题</div>
      <div>
        <el-input
          size="mini"
          v-model="topics"
          placeholder="多个使用,号分开"
        ></el-input>
      </div>
    </div>
    <select-project-component
      v-if="showSelectProject"
      @close="showSelectProject = false"
      @change="changeDevice"
    ></select-project-component>
  </div>
</template>
<script>
import SelectProjectComponent from "@/components/select-project.vue";
import { mqttConfig } from "../types/mqtt.config.js";
export default {
  components: { SelectProjectComponent },
  data() {
    return {
      url: "",
      clientId: "",
      account: "",
      password: "",
      topics: "",
      device: null,
      showSelectProject: false,
    };
  },
  watch:{
    device(val){
      if(val){
        this.topics = this.topo.store.data.mqttTopics = `Hexu/${val.deviceNo}/DevicePub`;
      }
      
    }
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.url = this.topo.store.data.mqtt || mqttConfig.hostname;
    try {
      this.topics =
      this.topo.store.data.mqttTopics ||
      `Hexu/${this.$Auth.device.deviceNo}/DeviceSub`;
    if (this.topo.store.data.mqttOptions) {
      this.clientId = this.topo.store.data.mqttOptions.clientId;
      this.account =
        this.topo.store.data.mqttOptions.username || mqttConfig.username;
      this.password =
        this.topo.store.data.mqttOptions.password || mqttConfig.password;
    } else {
      this.clientId = mqttConfig.clientId;
      this.account = mqttConfig.username;
      this.password = mqttConfig.password;
    }

    this.device = this.$Auth.device;
    } catch (error) {
      this.$message.warning('未选择设备')
    }
    
  },
  destroyed() {
    // this.topo.store.data.mqtt = this.url;
    // this.topo.store.data.mqttTopics = this.topics;
    // this.topo.store.data.mqttOptions = {
    //   clientId: this.clientId,
    //   username: this.account,
    //   password: this.password,
    //   // 如果clientId不为空，默认会随机重新生成一个clientId，避免连接冲突
    //   // 如果设置customClientId=true，不随机生成，使用用户自定义的固定的clientId
    //   customClientId: false,
    // };
    // this.topo.stageCanvas.connectMqtt();
  },
  methods: {
    init() {},
    removeDevice() {
      this.device = null;
      this.$Auth.device = null;
    },
    // 选择的设备
    changeDevice(device) {
      this.device = device;
      this.showSelectProject = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.data-setting-container {
  .event-properties-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .event-label {
      width: 120px;
    }
  }

  .device-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }
}
</style>